<template>
  <v-container>
    <div>
      <v-data-table
        :headers="headers"
        :items="items"
        class="elevation-1"
        :search="search"
      >
        <template v-slot:top>
          <v-toolbar flat>
            <v-btn color="primary" class="mr-3" to="/admin/jamaah/submit">Tambah Jamaah</v-btn>
            <v-btn color="primary" to="/admin/jamaah/statistik">Statistik Jamaah</v-btn>
          </v-toolbar>
          <v-text-field
              v-model="search"
              label="Search"
              class="mx-4"
            ></v-text-field>
          <!-- DIALOG HAPUS JAMAAH -->
          <v-dialog v-model="dialogDelete" max-width="600px">
            <v-card>
              <v-card-title>Apakah anda yakin akan menghapus data jamaah ini?</v-card-title>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn @click="deleteConfirm" color="primary">hapus</v-btn>
                <v-btn @click="dialogDelete = false" color="secondary">batal</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn icon @click="toFormEdit(item.kk_uid)">
            <v-icon small> mdi-pencil </v-icon>
          </v-btn>
          <v-btn icon @click="deleteItem(item)">
            <v-icon 
            small> 
            mdi-delete </v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </div>
  </v-container>
</template>

<script>
import router from "../../router";

export default {
  data() {
    return {
      dialogDelete: false,
      editedId: {
        uid: "",
        masjidUid: ""
      },
      editedIndex: -1,
      search: "",
      headers: [
        { text: "No", value: "no" },
        { text: "Nama", value: "name" },
        { text: "Alamat", value: "address" },
        { text: "Aksi", value: "actions" },
      ],
      items: [],
    };
  },
  mounted() {
    this.axios("/jamaah/list")
      .then((response) => {
        console.log(response.data);
        this.items = response.data.data;
        for(let i = 0; i < this.items.length; i++){
          this.items[i].no = i + 1;
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },
  methods: {
    toFormEdit(id) {
      // console.log(id)
      router.push({ name: 'Submit Data Jamaah', params: { id: id } })
    },
    deleteItem(item) {
      this.dialogDelete = true
      this.editedId.uid = item.kk_uid
      this.editedId.masjidUid = item.masjid_uid
      this.editedIndex = this.items.indexOf(item)
    },
    deleteConfirm() {
      const querystring = require('querystring');
      this.axios.post(`/jamaah/remove/${this.editedId.uid}`, querystring.stringify({ masjid_uid: this.editedId.masjidUid}))
      .then((response) => {
        console.log(response)
        if(response.data.status == true) {
          this.items.splice(this.editedIndex, 1)
          for(let i = this.editedIndex; i <this.items.length; i++) {
            this.items[i].no = i+1
          }
          // location.reload({forceReload: true})
        }
        this.dialogDelete = false
      })
      .catch((error) => {
        console.log(error)
        this.dialogDelete = false
      })
    }
  }
};
</script>
